import React from 'react';
import { useTenant } from '@/contexts/TenantContext';

const SiteSelector: React.FC = () => {
  const { activeTenant, activeSite, availableSites, switchSite, isLoading, error } = useTenant();

  if (isLoading) {
    return (
      <div className="flex items-center space-x-4">
        <div className="animate-pulse bg-gray-200 h-8 w-32 rounded"></div>
        <div className="animate-pulse bg-gray-200 h-8 w-48 rounded"></div>
      </div>
    );
  }

  if (error) {
    // Ne pas afficher d'erreur, rester silencieux
    return null;
  }

  if (!activeTenant || !activeSite) {
    // Ne pas afficher de message, rester vide
    return null;
  }

  return (
    <div className="flex items-center space-x-4">
      {/* Tenant Info - Hidden on mobile */}
      <div className="hidden lg:block text-sm">
        <div className="font-semibold text-gray-900">{activeTenant.name}</div>
        <div className="text-gray-500">({activeTenant.code})</div>
      </div>
      
      {/* Site Selector */}
      <div className="flex items-center space-x-2">
        <label htmlFor="site-select" className="hidden lg:block text-sm font-medium text-gray-700">
          Site:
        </label>
        <select
          id="site-select"
          value={activeSite.code}
          onChange={(e) => switchSite(e.target.value)}
          className="block px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 text-sm w-32 lg:w-48"
        >
          {availableSites.map((site) => (
            <option key={site.code} value={site.code}>
              {site.name} ({site.code})
            </option>
          ))}
        </select>
      </div>
      
      {/* Site Status Indicator */}
      <div className="flex items-center space-x-1">
        <div className={`w-2 h-2 rounded-full ${activeSite.is_active ? 'bg-green-500' : 'bg-red-500'}`}></div>
        <span className="hidden lg:block text-xs text-gray-500">
          {activeSite.is_active ? 'Actif' : 'Inactif'}
        </span>
      </div>
    </div>
  );
};

export default SiteSelector;